import { render } from "./drawing.vue?vue&type=template&id=4ac5730a"
import script from "./drawing.vue?vue&type=script&lang=js"
export * from "./drawing.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/components/drawing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ac5730a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ac5730a', __exports__)) {
    console.log('reload')
    api.reload('4ac5730a', __exports__)
  }
  
  module.hot.accept("./drawing.vue?vue&type=template&id=4ac5730a", () => {
    console.log('re-render')
    api.rerender('4ac5730a', render)
  })

}


export default __exports__